import { z } from 'zod'

export const contactFormSchema = z.object({
  name: z.string().min(2, { message: 'Der Vorname muss mindestens 2 Zeichen lang sein' }),
  surname: z.string().min(2, { message: 'Der Nachname muss mindestens 2 Zeichen lang sein' }),
  company: z.string().optional(),
  email: z.string().min(1, { message: 'Bitte geben Sie eine E-Mail-Adresse ein' }).email({ message: 'Ungültige E-Mail-Adresse' }),
  userMessage: z.string().optional(),
  service: z.string().optional(),
  terms: z.boolean().refine((value) => value === true, {
    message: 'Bitte bestätigen Sie die Datenschutzerklärung'
  })
})
